import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';
import { StatusPalettes } from '../constants';
import { StatusPaletteKey } from '../types';

/**
 * Vertical accent bar anchored to the left edge of the card. The card must
 * be `position: relative` with `overflow: hidden` so the bar clips to the
 * card's outer radius.
 */
export const StatusSideBar = memo(
  ({ palette }: { palette: StatusPaletteKey }) => {
    const { rpx } = useResponsiveContext();
    const { text } = StatusPalettes[palette];
    return (
      <View
        css={`
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: ${rpx(4)}px;
          background-color: ${text};
          z-index: 2;
        `}
      />
    );
  },
);
